import React from 'react';
import { connect } from 'react-redux';
import { getActiveLanguage, getTranslate } from './locale';


var mapStateToProps = function mapStateToProps(slice) {
  return function (state) {
    var scopedState = slice ? state[slice] : state;
    return {
      currentLanguage: getActiveLanguage(scopedState).code,
      translate: getTranslate(scopedState)
    };
  };
};

export var localize = function localize(Component) {
  var slice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return connect(mapStateToProps(slice))(Component);
};


//////////////////
// WEBPACK FOOTER
// ../~/react-localize-redux/es/Localize.js
// module id = 1327
// module chunks = 0